<template>
    <div>
        <div
            class="racing-tool-back"
            :class="hasPerms(item.authorityFlag) ? '' : 'no-permission'"
            @click="racingToolClicked(item)"
        >
            <div
                class="racing-tool-leftimg"
                :class="'coloricon' + item.menuTag"
            >
                <i class="icon iconfont" :class="item.icon"></i>
            </div>
            <div class="racing-tool-right">
                <div>{{ item.rightTitle }}</div>
                <div class="racing-tool-desc">{{ item.rightDesc }}</div>
            </div>
        </div>
    </div>
</template>
<script>
// import { hasPermission } from '@/permission/index.js'

export default {
  name: 'ToolComponent',
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data () {
    return {

    }
  },
  methods: {
    racingToolClicked (item) {
      // console.log(item)
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (item.showPop) {
        this.$emit('showPop', item)
        return
      }
      if (item.path) {
        this.$router.push(
          {
            path: item.path
          }
        )
      }
    },
    hasPerms: function (_flag) {
      return true
      // 根据权限标识和外部指示状态进行权限判断
      // return hasPermission(flag) // & !this.disabled
    }
  }
}
</script>
<style scoped lang="less">
.racing-tool-back {
    width: 100%;
    height: 120px;
    padding-top: 46px;
    padding-left: 10px;
    box-sizing: border-box;
    background: #f0f0f5;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
}

.racing-tool-back:hover {
    background-color: #e8e8ec;
}

.racing-tool-leftimg {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    position: absolute;
    left: 20px;
    top: -20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
        font-size: 28px;
    }
}

.racing-tool-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    color: #3d3c5a;
}

.racing-tool-desc {
    font-size: 12px;
    margin-top: 8px;
}
</style>
